'use client'
import type { CheckoutStdPageConfig } from './CheckoutPageStd'
import CheckoutPageStd from './CheckoutPageStd'

export * from './KlarnaCheckout'
export * from './Confirmation'
export * from './Checkout'

export { CheckoutPageStd, type CheckoutStdPageConfig }
